import { useCallback } from 'react';
import { LedgerActivityReportLedgerType, useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { sumTotalValues } from '../utils';
import { LedgerActivityReportUrlSearchValues } from '../schema';

interface UseLedgerActivityReportQueryProps {
    ledgerType: LedgerActivityReportLedgerType;
    filterValues: LedgerActivityReportUrlSearchValues;
}

export const useLedgerActivityReportQuery = ({ ledgerType, filterValues }: UseLedgerActivityReportQueryProps) => {
    const select = useCallback(
        (res) => ({
            ...res,
            ledgerTotal: sumTotalValues(res.ledgerActivityReportItems ?? [], 'value'),
        }),
        []
    );

    return useRepositorySuspenseQuery(
        'ledgerActivityReport',
        'get',
        {
            ledgerType,
            startDate: filterValues.startDate,
            endDate: filterValues.endDate,
            ownerId: filterValues.ownerId,
        },
        {
            select,
        }
    );
};
